<template>
  <div @mouseover="hover = true" @mouseleave="hover = false">
    <v-layout>        
        <v-flex xs12 sm6 md3 lg2 class="mr-2">
            <v-text-field label="name" v-model="category.CAT_NAME" /> 
        </v-flex>
        <v-flex xs6 sm3 md2 lg1 v-if="!category.CAT_PARENT_ID">
            <v-text-field label="Budget" v-model="category.CAT_BUDGET" />                     
        </v-flex>
        <v-btn v-if="!category.children.length && !category.CAT_INACTIVE && hover" flat small @click="deactivate(category)">deactivate</v-btn>
        <v-btn v-if="category.CAT_INACTIVE" flat small @click="reactivate(category)">reactivate</v-btn>
        <v-btn v-if="changed" flat small @click="save(category)">save</v-btn>
        <v-btn v-if="hover" flat small @click="add()">Add child node</v-btn>
    </v-layout>
  </div>
</template>

<script>
    import {apiPost} from '@/dal'
    export default {
        name: 'CategoryNode',
        props: ['value'],
        components: {},
        data: function() {
            return	{
                hover : false,
                orgValue : {},
                category : {CAT_ID : null, CAT_NAME : '', CAT_PARENT_ID : null, CAT_INACTIVE : null, CAT_BUDGET : 0, children:[]}
            }
        },


        created(){
        },

        computed:{
            changed(){             
                let val = JSON.stringify(this.category);
                return (val != this.orgValue);
            }
        },

        watch:{
            value:{
                handler(val){
                    if(val && val.category){                    
                        this.category.CAT_ID = val.category.CAT_ID;
                        this.category.CAT_NAME = val.category.CAT_NAME;
                        this.category.CAT_PARENT_ID = val.category.CAT_PARENT_ID;
                        this.category.CAT_INACTIVE = val.category.CAT_INACTIVE;
                        this.category.CAT_BUDGET = val.category.CAT_BUDGET;
                        this.category.children = val.children;
                        this.orgValue = JSON.stringify(this.category);
                    }
                }, immediate : true
            }
        },

        methods:{
            add(){
                let child = {CAT_ID : -1, CAT_NAME : '', CAT_PARENT_ID : this.category.CAT_ID, CAT_INACTIVE : null, CAT_BUDGET : 0};                
                this.$store.commit('addCategory',child);
               // this.$emit('childNodeAdded',child);
            },

            deactivate(category){
                category.CAT_INACTIVE = 1;
                apiPost('/category',category).then(()=>{
                    this.$store.dispatch('getCategories');
                })
                
            },

             reactivate(category){
                category.CAT_INACTIVE = 0;
                apiPost('/category',category).then(()=>{
                    this.$store.dispatch('getCategories');
                })
            },

            save(category){               
                apiPost('/category',category).then(()=>{
                    this.$store.dispatch('getCategories');
                })
                this.orgValue = JSON.stringify(this.category);
            },
        },
    }
</script>

<style scoped>

</style>
